<template>
    <Card :title="$t('crmAnalyticsPage.generalInformationCardTitle')">
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>{{ $t('crmAnalyticsPage.generalTableTitles.source') }}</th>
                        <th class="text-right">{{ $t('crmAnalyticsPage.generalTableTitles.orderCount') }}</th>
                        <th class="text-right">{{ $t('crmAnalyticsPage.generalTableTitles.orderDoneCount') }}</th>
                        <th class="text-right">{{ $t('crmAnalyticsPage.generalTableTitles.orderSum') }}</th>
                        <th class="text-right">{{ $t('crmAnalyticsPage.generalTableTitles.orderProfitSum') }}</th>
                        <th class="text-right">{{ $t('crmAnalyticsPage.generalTableTitles.orderProfitPercent') }}</th>
                        <th class="text-right">{{ $t('crmAnalyticsPage.generalTableTitles.orderAverageSum') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(generalInfo, sourceUuid) in generalBySourceUuid" :key="sourceUuid">
                        <td>
                            {{ getSourceName(sourceUuid) }}
                        </td>
                        <td class="text-right">
                            {{ formatNumber(generalInfo.orders_count) }}
                        </td>
                        <td class="text-right">
                            {{ formatNumber(generalInfo.orders_done_count) }}
                        </td>
                        <td class="text-right">
                            {{ Price.factory(generalInfo.orders_sum).toCurrencyString('UAH') }}
                        </td>
                        <td class="text-right">
                            {{ Price.factory(generalInfo.orders_profit_sum).toCurrencyString('UAH') }}
                        </td>
                        <td class="text-right">
                            {{ (generalInfo.orders_profit_percent || 0).toFixed(2) }}%
                        </td>
                        <td class="text-right">
                            {{ Price.factory(generalInfo.orders_average_sum).toCurrencyString('UAH') }}
                        </td>
                    </tr>
                    <tr>
                        <th>
                            {{ $t('crmAnalyticsPage.generalTableTitles.generalInfo') }}
                        </th>
                        <th class="text-right">
                            {{ formatNumber(calculateTotal('orders_count')) }}
                        </th>
                        <th class="text-right">
                            {{ formatNumber(calculateTotal('orders_done_count')) }}
                        </th>
                        <th class="text-right">
                            {{ Price.factory(calculateTotal('orders_sum')).toCurrencyString('UAH') }}
                        </th>
                        <th class="text-right">
                            {{ Price.factory(calculateTotal('orders_profit_sum')).toCurrencyString('UAH') }}
                        </th>
                        <th class="text-right">
                            {{ calculatePercent() }}%
                        </th>
                        <th class="text-right">
                            {{ Price.factory(calculateAverage()).toCurrencyString('UAH') }}
                        </th>
                    </tr>
                </tbody>
            </table>
        </div>
    </Card>
</template>
<script>
import Card from '../../../../../components/new/CardComponent.vue';

import Price from '../../../../../services/Price/Price';

export default {
    name: "GeneralInformation",
    components: {
        Card
    },
    props: {
        generalBySourceUuid: {
            type: Object,
            required: true
        },
        orderSourcesByUuid: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            Price
        }
    },
    methods: {
        getSourceName(sourceUuid) {
            if (sourceUuid === 'not_exists') {
                return this.$t('crmAnalyticsPage.unknownSource');
            }
            
            return this.orderSourcesByUuid[sourceUuid]?.name || this.$t('crmAnalyticsPage.unknownSource');
        },
        formatNumber(value) {
            return (value || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },
        calculateTotal(field) {
            let total = 0;

            for (const sourceUuid in this.generalBySourceUuid) {
                if (this.generalBySourceUuid.hasOwnProperty(sourceUuid)) {
                    total += this.generalBySourceUuid[sourceUuid][field] || 0;
                }
            }

            return total.toFixed(0);
        },
        calculateAverage() {
            const totalSum = Object.values(this.generalBySourceUuid)
                .reduce((sum, item) => sum + (item.orders_sum || 0), 0);
            const totalCount = Object.values(this.generalBySourceUuid)
                .reduce((sum, item) => sum + (item.orders_count || 0), 0);

            if (totalCount === 0) {
                return (0).toFixed(2);
            }

            return (totalSum / totalCount).toFixed(2);
        },
        calculatePercent() {
            const totalProfitSum = Object.values(this.generalBySourceUuid)
                .reduce((sum, item) => sum + (item.orders_profit_sum || 0), 0);
            const totalSum = Object.values(this.generalBySourceUuid)
                .reduce((sum, item) => sum + (item.orders_sum || 0), 0);

            if (totalSum === 0) {
                return (0).toFixed(2);
            }

            return (totalProfitSum / totalSum * 100).toFixed(2);
        }
    }

}
</script>